import axios from 'axios';
import React, { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';

import { Config } from '../../common/config';
import AlertModal from '../../components/alertModal';
import LeftMenu from '../../components/leftMenu';
import { getErrorMessage } from '../../components/utils';
import useStoreNo from '../../hooks/useStoreNo';
 

export default function QnaModify() {
  const navigate = useNavigate();
  
  const location = useLocation();
  const [modalOpen, setModalOpen] = useState(false); //모달 상태 관리 : 기본값 - 닫힘
  const [modalInfo, setModalInfo] = useState({
    isCancel: true,
    isConfirm: true,
    isMessage: true,
    headerMsg: '',
    actionFlag: '',
    mainMsg: '수정하시겠습니까?',
    action: '',
    isPercent: false,
  });
  const userInfo = useSelector(state => state.userInfo);
  const { qnaNo } = location.state;
  const storeNo = useStoreNo();

  const [formValues, setFormValues] = useState({
    category: '',
    userNo: userInfo.userNo,
    storeNo: userInfo.storeNo,
    title: '',
    qContent: '',
    aContent: '',
    file: null,
    notice: '',
  });

  const openModal = () => {
    if (!formValues.category || !formValues.title || !formValues.qContent) {
      // 필수 입력값이 없는 경우 모달창을 열고 반환
      setModalInfo({
        ...modalInfo,
        headerMsg: '알림',
        mainMsg: '모든 필수 입력값을 입력해주세요.',
        actionFlag: 'validate',
      });
      setModalOpen(true);
      return;
    }
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };
  const doModal = () => {
    if (modalInfo.actionFlag === 'login') {
      navigate('/login');
    }
    handleQnaModSubmit();
  };

  const handleInputChange = event => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const handleFileChange = event => {
    setFormValues({
      ...formValues,
      file: event.target.files[0],
    });
  };
  const formData = new FormData();
  formData.append('qnaCategory', formValues.category);
  formData.append('userNo', formValues.userNo);
  formData.append('title', formValues.title);
  formData.append('qContent', formValues.qContent);
  if (formValues.file) {
    formData.append('file', formValues.file);
  }
  formData.append('noticeYn', formValues.notice);

  // JWT refresh handled centrally in request layer

  const handleQnaModSubmit = async _unused => {
    try {
      await axios.put(
        `${Config.API_SERVER}qna/${qnaNo}`, // 여기에 API 엔드포인트 URL을 입력하세요
        formData, // 요청 본문에 formValues 추가
        {
          withCredentials: true,
        }
      );

      // 성공적으로 등록되었을 때의 작업

      navigate(`/${storeNo}/qna-list`);
    } catch (error) {
      setModalInfo(prev => ({
        ...prev,
        headerMsg: '알림',
        mainMsg: getErrorMessage(error?.response) || '수정 중 오류가 발생했습니다.',
        isCancel: false,
        isConfirm: true,
      }));
      setModalOpen(true);
      console.error('수정 오류:', error);
    }
  };

  const getQnaContent = useCallback(async _unused => {
    try {
      const response = await axios.get(
        `${Config.API_SERVER}qna/${qnaNo}`, // 여기에 API 엔드포인트 URL을 입력하세요
        {
          withCredentials: true,
        }
      );
      setFormValues({
        category: response.data.data.qnaCategory,
        userNo: userInfo.userNo,
        storeNo: userInfo.storeNo,
        title: response.data.data.title,
        qContent: response.data.data.qContent,
        aContent: response.data.data.aContent,
        //file: response.data.data.fileUrl,
        notice: response.data.data.noticeYn,
      });
    } catch (error) {
      console.error('수정데이터를 가져오지 못했습니다:', error);
    }
  }, [qnaNo, userInfo.userNo, userInfo.storeNo]);

  useEffect(() => {
    getQnaContent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qnaNo, userInfo.userNo, userInfo.storeNo]);

  return (
    <>
      <AlertModal
        open={modalOpen}
        close={closeModal}
        action={doModal}
        header={modalInfo.headerMsg}
        isConfirm={modalInfo.isConfirm}
        isMessage={modalInfo.isMessage}
        isCancel={modalInfo.isCancel}
      >
        {modalInfo.mainMsg}
      </AlertModal>

      <section className="location_box location_box_mypage">
        <ul className="location_001">
          <li>
            <NavLink to={storeNo ? `/${storeNo}/gift-list` : '/gift-list'}>
              홈
            </NavLink>
          </li>
          <li>
            <NavLink to={storeNo ? `/${storeNo}/qna-list` : '/qna-list'}>
              서비스 문의
            </NavLink>
          </li>
        </ul>
      </section>

      <main>
        <section className="contants_box contants_box_mypage">
          <LeftMenu pageName="qna" />

          <section className="rightcontant_box">
            <h2 className="tit_01">서비스 문의</h2>

            <article className="contants_box_03">
              <table className="member_box">
                <tbody>
                  <tr>
                    <th>구분</th>
                    <td>
                      <form>
                        <select
                          className="input_01"
                          name="category"
                          value={formValues.category}
                          onChange={handleInputChange}
                        >
                          <option value="QA01">서비스 관련</option>
                          <option value="QA02">기프트 발행</option>
                          <option value="QA03">기프트 구매선물</option>
                          <option value="QA04">기프트 사용검증</option>
                          <option value="QA05">입금</option>
                          <option value="QA06">환불</option>
                          <option value="QA07">기타</option>
                        </select>
                      </form>
                    </td>
                  </tr>
                  <tr>
                    <th>작성자 *</th>
                    <td>
                      <form>
                        <input
                          className="input_01"
                          name="writer"
                          value={userInfo.id}
                          type="text"
                          disabled
                        />
                      </form>
                    </td>
                  </tr>
                  <tr>
                    <th>제목 *</th>
                    <td>
                      <form className="form_01">
                        <input
                          className="input_03"
                          type="text"
                          name="title"
                          value={formValues.title}
                          maxLength={80}
                          onChange={handleInputChange}
                        />
                        <label className="label_01">
                          {formValues.title.length}/{80}
                        </label>
                      </form>
                    </td>
                  </tr>
                  <tr>
                    <th>내용 *</th>
                    <td>
                      <form>
                        <textarea
                          className="textarea_box"
                          id=""
                          name="qContent"
                          rows=""
                          cols=""
                          value={formValues.qContent}
                          onChange={handleInputChange}
                        ></textarea>
                      </form>
                    </td>
                  </tr>
                  <tr>
                    <th>파일 업로드</th>
                    <td>
                      <form>
                        <input
                          type="file"
                          name="file"
                          onChange={handleFileChange}
                        />
                      </form>
                      <p className="font_gray">
                        ※ jpg,jpeg,gif,png 파일 첨부 가능, 1개 파일을 3MByte까지
                        업로드 할 수 있습니다.
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th>공개유형</th>
                    <td>
                      <div className="signup_05">
                        <label className="check_box">
                          <input
                            type="radio"
                            name="notice"
                            value="Y"
                            checked={formValues.notice === 'Y'}
                            onChange={handleInputChange}
                          />
                          공개
                          <span className="check_radio"></span>
                        </label>
                        <label className="check_box">
                          <input
                            type="radio"
                            name="notice"
                            value="N"
                            checked={formValues.notice === 'N'}
                            onChange={handleInputChange}
                          />
                          비공개
                          <span className="check_radio"></span>
                        </label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </article>

            <p className="table_04 font_gray">
              ※ 고객님의 소중한 의견을 수렴하는 공간입니다. 내기프트에 바라는
              내용을 등록해 주세요.
              <br />
              상업적 글이나 무고, 욕설, 비방, 개인정보 등과 관련된 글을 올리는
              경우 삭제 될 수 있습니다.
            </p>
            <article className="button_box_01">
              <NavLink to={`/${storeNo}/qna-list`}>
                <button
                  type="button"
                  className="button_01 button_03 button_gray_line"
                >
                  취소
                </button>
              </NavLink>
              <button
                type="button"
                onClick={openModal}
                className="button_01 button_03 button_red"
              >
                수정
              </button>
            </article>
          </section>
        </section>
      </main>
    </>
  );
}
